import api from './api'

export default {
    actions: {
        deleteShiftReport_getShifts(_, processId) {
            return api.getShifts(processId);
        },
        deleteShiftReport_getObjects() {
            return api.getObjects();
        },
        deleteShiftReport_createRequest(_, payload) {
            return api.createRequest(payload);
        },
        deleteShiftReport_updateRequest(_, {id, payload}) {
            return api.updateRequest(id, payload);
        },
        deleteShiftReport_clearStepper({commit}) {
            commit(`deleteShiftReport_setAvailableShifts`, []);
            commit(`deleteShiftReport_setSelectedShifts`, []);
            commit(`deleteShiftReport_setSelectedObject`, null);
            commit(`deleteShiftReport_setSendOnCreate`, false);
            commit(`deleteShiftReport_setEditRequest`, null);
            return Promise.resolve();
        },
        deleteShiftReport_getRequests() {
            return api.getRequests();
        },
        deleteShiftReport_getRequestById(_, id) {
            return api.getRequest(id);
        },
        deleteShiftReport_getLogs(_, id) {
            return api.getLogs(id);
        },
        deleteShiftReport_getComments(_, requestId) {
            return api.getComments(requestId);
        },
        deleteShiftReport_addComment(_, payload) {
            return api.addComment(payload);
        },
        deleteShiftReport_deleteComment(_, payload) {
            return api.deleteComment(payload);
        },
        deleteShiftReport_editComment(_, {id, payload}) {
            return api.updateComment(id, payload);
        },
        deleteShiftReport_reject(_, payload) {
            return api.reject(payload);
        },
        deleteShiftReport_approve(_, payload) {
            return api.approve(payload);
        },
        async deleteShiftReport_submitCreatedRequest({dispatch}, request) {
            const requestId = Number(request && request.id);
            if (!requestId) {
                throw new Error('Не удалось определить созданную заявку');
            }

            const payload = {requestId};
            await dispatch('deleteShiftReport_sendToApprove', payload);

            const approved = Number(request.author) === Number(request.inspector);
            if (approved) {
                await dispatch('deleteShiftReport_approve', payload);
            }

            return {sent: true, approved};
        },
        deleteShiftReport_retry(_, payload) {
            return api.retry(payload);
        },
        deleteShiftReport_sendToApprove(_, payload) {
            return api.sendToApprove(payload);
        }
    },
    state: {
        availableShifts: [],
        selectedShifts: [],
        selectedObject: null,
        sendOnCreate: false,
        sortOptions: [
            {
                text: `Id заявки`,
                value: `id`
            },
            {
                text: `Постановщик`,
                value: `author`
            },
            {
                text: `Согласовывает`,
                value: `inspector`
            },
            {
                text: `Дата создания`,
                value: `createdAt`
            },
            {
                text: `Статус заявки`,
                value: `status`
            }
        ],
        sortBy: `status`,
        sortDesc: false,
        filter: ``,
        editRequest: null,
        selectedTab: 0
    },
    mutations: {
        deleteShiftReport_setAvailableShifts(state, value) {
            state.availableShifts = value;
        },
        deleteShiftReport_setSelectedShifts(state, value) {
            state.selectedShifts = value;
        },
        deleteShiftReport_setSelectedObject(state, value) {
            state.selectedObject = value;
        },
        deleteShiftReport_setSendOnCreate(state, value) {
            state.sendOnCreate = value;
        },
        deleteShiftReport_setFilter(state, value) {
            state.filter = value;
        },
        deleteShiftReport_setSortBy(state, value) {
            state.sortBy = value;
        },
        deleteShiftReport_setSortDesc(state, value) {
            state.sortDesc = value;
        },
        deleteShiftReport_setEditRequest(state, value) {
            state.editRequest = value;
        },
        deleteShiftReport_setSelectedTab(state, value) {
            state.selectedTab = value;
        }
    }
}
